export const CommonConstant = {
  imageFormat: 'format=thumbnail',
  videoFormat: 'mp4',
  imageDefaultWidth: '&width=900',
};
